import ApiService from '@/services/api.service';
import getters from '@/store/global';

const state = {
    horoscope: [],
    errors: {}
};

getters['fetchHoroscope'] = function(state) { return state.horoscope }

const actions = {
    get(context) {
        return ApiService
            .get('horoscopes/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_HOROSCOPE', response.data);
            })
            .catch(() => {
                throw new Error('Something goes wrong');
            })
    },
};

const mutations = {
    SET_HOROSCOPE(state, horoscope) {
        state.horoscope = horoscope;
        state.errors = {};
    },
    SET_ERROR(state, errors) {
        state.errors = errors;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
